// Import only browser entries absent on the server. Server edits take precedence.
export function getMissingBrowserTemplates(localTemplates, localGroups, remoteTemplates, remoteGroups) {
  const vendorId = (entry) => String(entry.vendorId || entry.vendor_id || entry.vendorLabel || "")
    .trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  const key = (entry, field) => JSON.stringify([vendorId(entry), String(entry[field] || "").trim()]);
  const selectMissing = (local, remote, field, valid) => {
    const seen = new Set(remote.map((entry) => key(entry, field)));
    return local.filter((entry) => {
      if (!entry || !vendorId(entry) || !String(entry[field] || "").trim() || !valid(entry)) return false;
      const id = key(entry, field);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    }).map((entry) => ({ ...entry, vendorId: vendorId(entry) }));
  };
  return {
    templates: selectMissing(localTemplates, remoteTemplates, "name", (entry) =>
      Boolean(String(entry.outputTemplate || entry.output_template || "").trim())),
    groups: selectMissing(localGroups, remoteGroups, "label", () => true),
  };
}
